// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"282":"ca59ec33","465":"de9344e2"}[chunkId] + ".chunk.js";
};